import type { PaylineRoute, PresentedLineWin } from '../rendering/types';

export const PAYLINE_COLORS = [
  0xffd45f, 0x65d9ff, 0xff7398, 0x75f0bb, 0xc9a0ff,
  0xffa95f, 0x91ff68, 0xf877ff, 0x67a7ff, 0xffffff,
] as const;

export interface VisibleLinePoint {
  readonly reel: number;
  readonly row: number;
}

export interface WinShowcaseStep {
  readonly line: PresentedLineWin;
  readonly startAtMs: number;
  readonly durationMs: number;
}

export interface WinShowcasePlan {
  readonly initial: readonly WinShowcaseStep[];
  readonly initialCompleteAtMs: number;
  readonly cycleIntervalMs: number;
}

export function getVisibleLineRoute(route: PaylineRoute, count: number): readonly VisibleLinePoint[] {
  const safeCount = Math.max(0, Math.min(route.length, Math.trunc(count)));
  return route.slice(0, safeCount).map((row, reel) => ({ reel, row }));
}

export function createWinShowcasePlan(
  lines: readonly PresentedLineWin[],
  turbo: boolean,
  reducedMotion: boolean,
): WinShowcasePlan {
  if (lines.length === 0) return { initial: [], initialCompleteAtMs: 0, cycleIntervalMs: 0 };
  const duration = reducedMotion ? 0 : turbo ? 110 : lines.length >= 6 ? 180 : 250;
  const initial = lines.map((line, index) => ({
    line,
    startAtMs: index * duration,
    durationMs: duration,
  }));
  return {
    initial,
    initialCompleteAtMs: duration * lines.length,
    cycleIntervalMs: reducedMotion || lines.length < 2 ? 0 : turbo ? 900 : 1450,
  };
}

export function getCycledWinIndex(lineCount: number, elapsedMs: number, intervalMs: number): number {
  if (lineCount <= 0 || intervalMs <= 0) return -1;
  return Math.floor(Math.max(0, elapsedMs) / intervalMs) % lineCount;
}
